import { PhoneTextInput } from "cerulean";
import { Control, Controller, FieldValues, Path } from "react-hook-form";

interface PhoneNumberInputProps<T extends FieldValues> {
  control: Control<T, unknown>;
  name: Path<T>;
  label: string;
}

function PhoneNumberInput<T extends FieldValues>(props: PhoneNumberInputProps<T>) {
  return (
    <Controller
      name={props.name}
      control={props.control}
      render={({ field: { onChange, onBlur, value }, fieldState: { error } }) => (
        <PhoneTextInput
          label={props.label}
          value={value || ""}
          onChange={onChange}
          onBlur={onBlur}
          error={error?.message}
        />
      )}
    />
  );
}

export { PhoneNumberInput };
